import { useState, useEffect, useRef } from "react";
import { MessageSquare, X } from "lucide-react";
import UserSupport from "./Support";

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const chatRef = useRef(null);

  const toggleChatbot = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the chat is open and the click is outside the chat widget
      if (
        isOpen &&
        chatRef.current &&
        !chatRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    // Add event listener when component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]); // Only re-run if isOpen changes

  return (
    <div className="fixed bottom-40 md:bottom-32 right-6 z-50" ref={chatRef}>
      {isOpen ? (
        <div className="relative bg-white rounded-lg shadow-xl border border-gray-200 w-[90vw] max-w-[600px] h-[80vh] max-h-[600px] flex flex-col">
          <button
            onClick={toggleChatbot}
            className="absolute top-2 right-2 p-2 text-gray-600 hover:text-gray-800"
          >
            <X size={24} />
          </button>
          <div className="flex-1 overflow-y-auto">
            <UserSupport />
          </div>
        </div>
      ) : (
        <button
          onClick={toggleChatbot}
          className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-4 shadow-lg flex items-center justify-center"
        >
          <MessageSquare size={24} />
        </button>
      )}
    </div>
  );
};

export default ChatbotWidget;
